import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import { comics } from "@/mocks/comics";

const featured = [comics[0], comics[4], comics[6]];
const grid = [comics[1], comics[2], comics[3], comics[5], comics[7], comics[8], comics[10], comics[11], comics[9]];

export default function Recommend() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo
        title="卡通动漫第一页编辑推荐 - 高分口碑漫画精选"
        description="卡通动漫第一页编辑推荐，内容团队人工筛选的高分口碑漫画精选，兼顾品质、题材多样性与独特阅读体验，每一部都值得细细品读。"
        keywords="卡通动漫第一页编辑推荐,精选漫画,高分漫画,口碑佳作"
      />
      <Navbar />

      <main className="bg-background-50 pt-16 md:pt-20">
        <div className="container-x">
          <nav className="flex items-center gap-2 py-6 text-sm text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-700 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line" style={{ fontSize: "16px" }}></i>
            <span className="text-foreground-800">编辑推荐</span>
          </nav>

          <div className="mb-8 rounded-2xl bg-gradient-to-r from-primary-500 to-accent-500 p-6 text-background-50 md:p-8">
            <h1 className="flex items-center gap-3 font-display text-2xl md:text-3xl">
              <i className="ri-star-smile-fill" style={{ fontSize: "26px" }}></i>
              编辑推荐
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
              这里是内容团队的精选清单。比起追逐热度，我们更愿意把那些画风出彩、故事耐读、题材多元的作品摆到你面前——它们未必是最火的，但一定都值得一看。
            </p>
          </div>

          {/* 本期重点 */}
          <h2 className="mb-5 font-display text-2xl text-foreground-950">本期重点推荐</h2>
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            {featured.map((c, i) => (
              <Link
                key={c.id}
                to={`/comic/${c.id}`}
                className="group flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1 hover:ring-accent-300"
                aria-label={`查看重点推荐《${c.title}》`}
              >
                <div className="relative aspect-[4/3] w-full overflow-hidden">
                  <img src={c.cover} alt={`本期重点推荐《${c.title}》封面`} title={`${c.title} 重点推荐`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                    重点推荐
                  </span>
                  <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-900/70 font-display text-lg text-background-50">
                    {i + 1}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{c.category}</span>
                    <span className="text-xs text-foreground-400">{c.views}</span>
                    <span className="ml-auto flex items-center gap-1 text-primary-600"><i className="ri-star-fill" style={{ fontSize: "14px" }}></i> {c.score}</span>
                  </div>
                  <h3 className="mt-2 font-display text-xl text-foreground-950 group-hover:text-accent-700 transition-colors">{c.title}</h3>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{c.detail}</p>
                  <p className="mt-3 border-l-2 border-accent-300 pl-3 text-xs text-foreground-500">
                    编辑点评：{c.tags[0]}题材的耐读佳作，值得沉浸其中慢慢品。
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* 高分口碑 */}
          <h2 className="mb-5 mt-12 font-display text-2xl text-foreground-950">高分口碑精选</h2>
          <div className="grid grid-cols-2 gap-4 pb-14 sm:grid-cols-3 md:gap-5">
            {grid.map((c) => (
              <Link
                key={c.id}
                to={`/comic/${c.id}`}
                className="group flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1 hover:ring-primary-300"
                aria-label={`查看精选《${c.title}》`}
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden">
                  <img src={c.cover} alt={`编辑精选《${c.title}》封面`} title={`${c.title} 编辑精选`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">编辑精选</span>
                  <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-foreground-900/80 px-2 py-1 text-xs text-background-50">
                    <i className="ri-star-fill" style={{ fontSize: "12px" }}></i> {c.score}
                  </span>
                </div>
                <div className="p-3">
                  <h3 className="truncate font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">{c.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{c.category} · {c.updates}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}